import { render, staticRenderFns } from "./LicenseGen.vue?vue&type=template&id=98c13012"
import script from "./LicenseGen.vue?vue&type=script&lang=js"
export * from "./LicenseGen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports